import styled from 'styled-components';
import { Section } from '../Section';

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	height: 609px;
	overflow-y: scroll;
	width: 380px;
	margin-top: 30px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledSection = styled(Section)`
	${StyledDivider} {
		&:last-of-type {
			display: none;
		}
	}
`;

export { StyledSettingsContainer, StyledSection, StyledDivider };
